import React from 'react'
import Equifax from '../../Assets/Equifax.svg.png'
import Reportes from '../../Assets/Reportes v4.avif'
import { FcDocument } from 'react-icons/fc'
import { AiFillProduct } from 'react-icons/ai'
import { GrContact } from 'react-icons/gr'

function Navbar() {
    return (
        <div className='w-full'>
            <div className='w-full container mx-auto   items-center justify-between mt-0 py-4 text-black px-5 md:px-0 flex '>
                <a className='text-black no-underline hover:no-underline font-bold text-2xl lg:text-4xl' href='/'>
                    <img src={'https://s3.sa-east-1.amazonaws.com/imagenes.simple/Simplesoluciones/Reportes+v4.avif'} alt='Reportes' className='w-[200px]' />
                </a>
                <div className=' space-x-4 hidden md:flex'>
                    <a href='/' className='no-underline hover:underline cursor-pointer' 
                    >
                        Inicio
                    </a>
                    <div className='no-underline hover:underline cursor-pointer'  onClick={() =>
                        document.getElementById('product').scrollIntoView({ behavior: 'smooth' })}
                    >
                        Productos
                    </div>
                    <div className='no-underline hover:underline cursor-pointer'  onClick={() =>
                        document.getElementById('form').scrollIntoView({ behavior: 'smooth' })}
                    >
                        Contacto
                    </div>
                </div>
                <div className='flex flex-col '>
                    <p className='text-sm'>
                        Distribuidor autorizado de
                    </p>
                    <img src={Equifax} alt='Equifax' className='md:w-[200px] w-[100px]' />
                </div>
            </div>
            <div className="md:hidden fixed bottom-0 z-50 w-full py-2 bg-white border-t border-[slate-400] h-[84px]">
                <div className="flex flex-row justify-center space-x-1 mb-2">
                    <div className='flex flex-col justify-center items-center p-3' onClick={() => document.getElementById('product').scrollIntoView({ behavior: 'smooth' })}>
                        <AiFillProduct  className='text-3xl' />
                        <p className='text-xs'>Productos</p>
                    </div>
                    <div className='flex flex-col justify-center items-center p-3' onClick={() => document.getElementById('form').scrollIntoView({ behavior: 'smooth' })}>
                        <GrContact  className='text-3xl' />
                        <p className='text-xs'>Contacto</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar